//#region src/sdk-lockstep.ts
/**
* The SDK lockstep line, and the package that stands for it (plan 2026-10-09-app-channel-sdk-version,
* D-6). One declaration for the `zion` CLI (`zion sdk status`, `zion sdk upgrade`,
* `zion app list --sdk`) and the CP console's Release channels table, so both name one SDK version
* for one set of `@zion/*` packages by one rule. `tools/zion-app` imports these names from this
* package (R-001).
*/
/**
* The SDK lockstep line: the one `fixed` group in `.changeset/config.json`, in its order. Every
* member carries one version, so the door's `latest` of one member is the `latest` of all.
* `@zion/sdk-cp-dp-contracts` and every other `@zion/*` package are outside it. A test holds this
* list equal to the config.
*/
const LOCKSTEP_PACKAGES = Object.freeze([
	"@zion/sdk-contracts",
	"@zion/sdk-node",
	"@zion/sdk-nestjs",
	"@zion/sdk-react",
	"@zion/sdk-surfaces",
	"@zion/sdk-surfaces-react",
	"@zion/sdk-test",
	"@zion/design-tokens",
	"@zion/sdk-docs",
	"@zion/zion-app"
]);
/** The lockstep member that stands for the line when a set of names holds it. */
const SDK_REFERENCE_PACKAGE = "@zion/sdk-node";
/**
* The package that stands for the lockstep line, from a set of `@zion/*` names (the names a
* lockfile resolves, or the keys of a release's `sdkVersions`). In order: `@zion/sdk-node`; the
* first `@zion/sdk-*` lockstep member by name; then `@zion/zion-app`; then the first lockstep
* member by name. `undefined` when no name is a lockstep member. Pure.
*/
function chooseReferencePackage(names) {
	const members = [...names].filter((n) => LOCKSTEP_PACKAGES.includes(n)).sort();
	if (members.includes("@zion/sdk-node")) return SDK_REFERENCE_PACKAGE;
	return members.find((n) => n.startsWith("@zion/sdk-")) ?? members.find((n) => n === "@zion/zion-app") ?? members[0];
}
//#endregion
export { LOCKSTEP_PACKAGES, SDK_REFERENCE_PACKAGE, chooseReferencePackage };

//# sourceMappingURL=sdk-lockstep.js.map